export default __webpack_public_path__ + "static/media/black_friday.7ffc48fb.jpg";